import React from 'react';
import Button from '../Button.jsx';
import TransactionSearch from '../TransactionSearch.jsx';
import InlineCircleLoader from '../InlineCircleLoader.jsx';
import { SORT_BEST_MATCH, SORT_NEWEST } from '../../../utilities/transactionFinder/transactionSearch.js';

const SEARCH_SORTS = [
	{ sort: SORT_BEST_MATCH, label: 'Best match' },
	{ sort: SORT_NEWEST, label: 'Newest' },
];

/**
 * The bar over the transactions list: search and Add on one line, then the bank-activity filters as
 * toggle pills. "Unbudgeted bank activity" swaps the list for the bank records no transaction is
 * linked to, which since imports replaced Plaid are mostly the transfers and card payments an import
 * keeps off the budget. "Include hidden" only means something while those are shown, so it appears
 * only then. While searching, a line under them counts the results and picks their order. Styled in
 * css/_transactions_toolbar.scss.
 */
export default function TransactionsToolbar({
	onAdd,
	showingBankTransactions,
	showingHiddenBankTransactions,
	bankTransactionsLoading,
	onToggleBankTransactions,
	onToggleHiddenBankTransactions,
	searchText,
	searchResultCount,
	searchSort,
	onSearchSortChange,
}) {
	return (
		<React.Fragment>
			<div className='transactions_toolbar'>
				<TransactionSearch/>
				<Button
					className='transactions_toolbar__add'
					onClick={onAdd}
					aria-label='Add transaction'
				>
					<i className='material-icons'>add</i>
					<span className='transactions_toolbar__add-label'>Add transaction</span>
				</Button>
			</div>
			<div className='transactions_filters'>
				<button
					type='button'
					className='btn-flat transactions_filter'
					aria-pressed={showingBankTransactions}
					disabled={bankTransactionsLoading}
					onClick={onToggleBankTransactions}
				>
					<i className='material-icons'>account_balance</i>
					Unbudgeted bank activity
					{bankTransactionsLoading &&
					<InlineCircleLoader size='extra-small'/>
					}
				</button>
				{showingBankTransactions &&
				<button
					type='button'
					className='btn-flat transactions_filter'
					aria-pressed={showingHiddenBankTransactions}
					onClick={onToggleHiddenBankTransactions}
				>
					<i className='material-icons'>visibility</i>
					Include hidden
				</button>
				}
			</div>
			{showingBankTransactions && !searchText &&
			<div className='transactions_filter_hint'>
				Bank records with no transaction in the budget, mostly transfers and card payments.
			</div>
			}
			{searchText &&
			<div className='transactions_search_label'>
				<span>
					{searchResultCount === null ? 'Searching for'
						: `${searchResultCount} ${searchResultCount === 1 ? 'result' : 'results'} for`}
					{' '}“{searchText}”
				</span>
				<span className='transactions_search_sort' role='group' aria-label='Order results by'>
					{SEARCH_SORTS.map(({ sort, label }) => (
						<button
							key={sort}
							type='button'
							className='btn-flat transactions_filter'
							aria-pressed={searchSort === sort}
							onClick={() => onSearchSortChange(sort)}
						>
							{label}
						</button>
					))}
				</span>
			</div>
			}
		</React.Fragment>
	);
}
